import React from 'react';
import { Button } from './ui/Button';
import { Check, Sparkles } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { getCartUrl } from '../utils/cartUrls';
interface WhyWeDoThisProps {
  bump1: boolean;
  bump2: boolean;
}
export function WhyWeDoThisSection({
  bump1,
  bump2
}: WhyWeDoThisProps) {
  const basePrice = 7.49;
  const bumpPrice = 9.97;
  const finalPrice = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const benefits = ['El mapa exacto para resetear tu metabolismo en 28 días.', 'El secreto para bloquear la enzima COX-2 (causante de la hinchazón).', 'La libertad de comer chocolate y postres sin inflamar tu cuerpo.', 'Acceso inmediato y de por vida a todas las actualizaciones.', 'La respuesta definitiva a por qué las otras dietas fallaron. Y no era tu culpa.'];
  return <section className="py-4 bg-transparent" data-id="element-570">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-571">
        <div className="max-w-4xl mx-auto" data-id="element-572">
          <div className="bg-white rounded-2xl shadow-xl border border-sage/5 p-6 md:p-8" data-id="element-573">
            <div className="flex items-center gap-2 mb-4" data-id="element-574">
              <Sparkles className="w-5 h-5 text-gold" data-id="element-575" />
              <h3 className="text-xl font-serif font-bold text-sage" data-id="element-576">
                💡 Por qué hacemos esto:
              </h3>
            </div>
            <p className="text-sage/80 text-base leading-snug mb-4" data-id="element-577">
              Este precio es parte de nuestra campaña por el Mes de la Mujer.
              Queremos que 10.000 mujeres activen su Reset Metabólico este mes,
              sin que el presupuesto sea una barrera. Una vez que termina la
              campaña, el precio vuelve a $97. No hay fecha exacta de cierre.
              Puede ser mañana. Puede ser en una hora.
            </p>

            <h4 className="text-lg font-serif font-bold text-sage mb-3" data-id="element-578">
              Lo que recibes por $7.49:
            </h4>
            <ul className="space-y-2 mb-6" data-id="element-579">
              {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-580">
                  <div className="bg-gold/20 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-581">
                    <Check className="w-3.5 h-3.5 text-gold-dark" data-id="element-582" />
                  </div>
                  <span className="text-sage/80 font-medium text-sm" data-id="element-583">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="text-center" data-id="element-584">
              <a href={getCartUrl(bump1, bump2)} onClick={e => trackAddToCart(e)} target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto" data-id="element-585">
                <Button size="lg" variant="primary" className="w-full sm:w-auto px-10 shadow-gold/30 text-sm" data-id="element-586">
                  SÍ, QUIERO MI PROTOCOLO RESET POR ${finalPrice.toFixed(2)}{' '}
                  ANTES QUE SE ACABEN LOS CUPOS
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}